import React, { useEffect, useMemo, useState } from 'react'
import { Document } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import './termsService.css'

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const normalizeList = (payload) => {
    if (Array.isArray(payload)) return payload
    if (payload && typeof payload === 'object') {
        if (Array.isArray(payload.results)) return payload.results
        if (Array.isArray(payload.data)) return payload.data
        if (payload.title || payload.description) return [payload]
    }
    return []
}

const formatDate = (value) => {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

const TermsService = ({ onBack }) => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let mounted = true
        service
            .get(endpoints.users.termsAndConditions, {}, { silent: true })
            .then(({ data }) => {
                if (!mounted) return
                const list = normalizeList(data?.data)
                const activeList = list.filter((item) => item?.is_active !== false)
                setItems(activeList.length ? activeList : list)
            })
            .catch(() => {
                if (mounted) setItems([])
            })
            .finally(() => {
                if (mounted) setLoading(false)
            })

        return () => {
            mounted = false
        }
    }, [])

    const latestUpdated = useMemo(() => {
        const dates = items.map((item) => item?.updated_at).filter(Boolean)
        return dates[0] || ''
    }, [items])

    return (
        <div className='termService'>
            {onBack && (
                <button type='button' className='policyPage__backLink' onClick={onBack}>
                    <BackArrow /> Back
                </button>
            )}

            <div className='policyHero'>
                <span className='policyHero__icon'>
                    <img src={Document} alt="" />
                </span>
                <h1 className='policyHero__title'>Terms &amp; Conditions</h1>
                <p className='policyHero__meta'>
                    {latestUpdated ? `Last updated: ${formatDate(latestUpdated)}` : 'Please read these terms carefully'}
                </p>
            </div>

            <div className='policyBody'>
                {loading ? (
                    <div className='policyLoading'>
                        <span className='policyLoading__bar' />
                        <span className='policyLoading__bar' />
                        <span className='policyLoading__bar policyLoading__bar--short' />
                    </div>
                ) : items.length ? (
                    items.map((item, index) => (
                        <div className='policyBlock' key={item.id || item.title}>
                            {/* <span className='policyBlock__num'>{index + 1}</span> */}
                            <div className='policyBlock__content'>
                                {/* <div className='policyBlock__title'>{item.title || 'Terms of Service'}</div> */}
                                {item.description ? (
                                    <div
                                        className='policyBlock__desc'
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    />
                                ) : (
                                    <p className='policyBlock__desc'>No description available.</p>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className='policyBody__empty'>Terms and conditions are not available right now.</p>
                )}
            </div>
        </div>
    )
}

export default TermsService
